import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ServiceGrouping } from 'src/app/models/enums/service.enum';
import { ServiceStatus } from 'src/app/models/service.model';
import {
  LoadServices,
  LoadServicesFail,
  LoadServicesSuccess,
} from '../../store';
import { SingleValueKPI } from '../types';
import { ChartType } from '../types/chart-type.types';
import { ChartService } from './chart.service';

@Injectable()
export class ActiveServicesChartService extends ChartService<SingleValueKPI> {
  public readonly chart$ = this.chartsDataLoader({
    request: LoadServices,
    success: LoadServicesSuccess,
    failure: LoadServicesFail,
  }).pipe(
    map(({ loading, data }) => {
      const dataValue: number =
        data?.filter((s) => s.Status__c === 'In Service').length || 0;

      return {
        ngClass: [],
        loading,
        data: {
          type: ChartType.SINGLE,
          id: 'Active Services',
          title: 'Active Services',
          value: dataValue,
          linkEnabled: true,
          linkParams: {
            groupBy: ServiceGrouping.Status,
            status: ServiceStatus.InService,
          },
          hyperlink: '/services',
        } satisfies SingleValueKPI,
      };
    }),
  );
}
